import Cookies from "js-cookie";

const newTechCompare = {
  compareLinkCountEl: null,

  init() {
    this.compareLinkCountEl = $(".compare-link-count");
    this.headerCount();
    this.events();
  },

  /**
   * Add counter to compare button
   */
  headerCount() {
    if (0 == this.compareLinkCountEl.length) {
      return;
    }

    const compare = Cookies.get("_cab_compare");
    const machineryCompare = compare ? JSON.parse(compare) : [];

    newTechCompare.compareLinkCountEl.text(machineryCompare.length);
    if (machineryCompare.length > 0) {
      newTechCompare.compareLinkCountEl.removeClass("hidden");
    } else {
      newTechCompare.compareLinkCountEl.addClass("hidden");
    }
  },

  events() {
    $(document).on("click", ".btn-compare, .compare-product__top", function (e) {
      const productId = $(this).data("id");

      if ($(this).hasClass("compare-product__top") && $(this).data("type") == "remove") {
        window.location = $(this).data("url");
        console.log("window.location", $(this).data("url"));
        return;
      };

      console.log("productId", productId);
      console.log("this", this);
      console.log("e", e);

      const compare = Cookies.get("_cab_compare");
      const machineryCompare = compare ? JSON.parse(compare) : [];

      const index = machineryCompare.indexOf(productId);
      if (index > -1) {
        $(this).find(".text").html(translations.add_to_compare);
        $(this).attr("data-type", "add");

        machineryCompare.splice(index, 1);
      } else {
        $(this).find(".text").html(translations.remove_from_compare);
        $(this).attr("data-type", "remove");

        machineryCompare.push(productId);
      }

      Cookies.set("_cab_compare", JSON.stringify(machineryCompare));

      // Set count.
      newTechCompare.compareLinkCountEl.text(machineryCompare.length);
      if (machineryCompare.length > 0) {
        newTechCompare.compareLinkCountEl.removeClass("hidden");
      } else {
        newTechCompare.compareLinkCountEl.addClass("hidden");
      }
    });
  },
};

export default newTechCompare;
